<div class="modal-editar-contato modal-cadastro-contato flex-direction-column" appArrastarFecharSheet (arrastouParaFechar)="cancelar()">
  <div class="modal-editar-contato-cabecalho flex-direction-row justify-between align-center">
    <span class="modal-editar-contato-titulo">Cadastrar Contato</span>
    <button type="button" class="modal-editar-contato-fechar-x" title="Fechar" (click)="cancelar()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-editar-contato-linha"></div>

  <form class="modal-editar-contato-corpo modal-cadastro-contato-corpo flex-direction-column gap-15" (ngSubmit)="salvar()">
    <app-campo-texto
      label="Nome do Contato"
      placeholder="Digite o nome do Contato"
      name="nome"
      [(ngModel)]="nome"
      [erro]="erroNome"
      [disabled]="salvando()"
    ></app-campo-texto>

    <app-campo-telefone
      label="Número do Contato"
      placeholder="Digite o número"
      name="telefone"
      [(ngModel)]="telefone"
      [erro]="erroTelefone"
      [disabled]="salvando()"
    ></app-campo-telefone>

    <app-campo-texto
      label="E-mail do Contato"
      placeholder="Digite o e-mail do Contato"
      name="email"
      [(ngModel)]="email"
      [erro]="erroEmail"
      [disabled]="salvando()"
    ></app-campo-texto>

    <button type="submit" hidden></button>
  </form>

  <div class="modal-editar-contato-linha"></div>

  <div class="modal-editar-contato-rodape flex-direction-row justify-end gap-10">
    <button type="button" class="modal-editar-contato-btn-cancelar" (click)="cancelar()">Cancelar</button>
    <app-botao label="Salvar" [icone]="''" largura="auto" [disabled]="salvando()" (aoClicar)="salvar()"></app-botao>
  </div>
</div>
